import { render, staticRenderFns } from "./UpperLowerBarGraph.vue?vue&type=template&id=6dbb8572"
import script from "./UpperLowerBarGraph.vue?vue&type=script&lang=js"
export * from "./UpperLowerBarGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports